(function () {
  'use strict';
  if (window.__nsObiProffieOffer) return;
  window.__nsObiProffieOffer = true;
  var scheduled = false, focusCore = null;
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function state() {
    var root = document.querySelector('[data-ns-native-promo][data-promo-key="freeluke"]');
    var template = document.querySelector('[data-ns-obi-offer-template]');
    if (!root || !template) return null;
    var json = root.querySelector('[data-ns-purchase-variants]');
    var rules = root.querySelector('[data-ns-variant-gift-rules]');
    var picker = document.querySelector('variant-picker[handle="obi-ep1"]');
    var form = picker && document.getElementById(picker.getAttribute('form-id'));
    var input = form && form.querySelector('[name="id"]');
    if (!json || !rules || !picker || !input) return null;
    var variants = JSON.parse(json.textContent), config = JSON.parse(rules.textContent);
    var current = variants.find(function (v) { return String(v.id) === input.value; });
    if (!current) return null;
    return { root: root, template: template, picker: picker, variants: variants, config: config, current: current };
  }
  function sameBlade(s, core) {
    return s.variants.find(function (v) { return v.option1 === core && v.option2 === s.current.option2 && v.option3 === s.current.option3; });
  }
  function gift(s, variant) {
    if (!variant) return null;
    var rule = (s.config.variant_gift_rules || []).find(function (r) { return r.purchase_variant_ids.some(function (id) { return String(id).split('/').pop() === String(variant.id); }); });
    var id = String(rule ? rule.gift_variant_id : s.config.gift_variant_id).split('/').pop();
    var option = Array.from(s.root.querySelectorAll('[data-ns-native-promo-gift]')).find(function (o) { return o.dataset.variantId === id; });
    var image = option && option.querySelector('img');
    var title = option && option.querySelector('strong');
    var name = rule && rule.gift_option && rule.gift_option.title || (title && title.textContent.split('·')[0].trim()) || 'gift';
    var handle = rule && rule.gift_option && rule.gift_option.handle || s.config.gift_handle;
    if (handle === 'luke-saber') name = 'Luke ' + (rule.gift_option.variant_title || '').split('/')[0].trim();
    if (handle === 'free-luke-v1') name = 'Luke Baselit';
    name = name.replace(/^free\s+/i, '');
    return { name: name, image: image && (image.currentSrc || image.src), available: Boolean(option), id: id };
  }
  function money(panel, cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: panel.dataset.currency, maximumFractionDigits: 2 }).format(cents / 100);
  }
  function selectCore(core) {
    var s = state(), variant = s && sameBlade(s, core);
    if (!variant || !variant.available) return;
    var field = s.picker.querySelector('fieldset');
    var label = Array.from(field.querySelectorAll('label.block-swatch')).find(function (l) { var title = l.querySelector('.ns-variant-title'); return title && title.textContent.trim() === core; });
    var input = label && document.getElementById(label.getAttribute('for'));
    if (input && !input.checked && !input.disabled) { focusCore = core; input.click(); }
  }
  function render() {
    scheduled = false;
    var s = state();
    if (!s) return;
    var field = s.picker.querySelector('fieldset');
    if (!field) return;
    var panel = s.picker.querySelector('[data-ns-obi-offer]');
    if (!panel) {
      panel = s.template.content.firstElementChild.cloneNode(true);
      field.insertAdjacentElement('afterend', panel);
      panel.addEventListener('click', function (event) { var button = event.target.closest('[data-ns-obi-core]'); if (button && !button.disabled) selectCore(button.dataset.nsObiCore); });
    }
    var live = s.root.dataset.nsEligibility !== 'false';
    panel.hidden = !live;
    if (!live) { if (s.root.dataset.obiGiftCta) { delete s.root.dataset.obiGiftCta; if (window.NSPromoAtc) window.NSPromoAtc.refresh(); } return; }
    var activeGift = gift(s, s.current), core = s.current.option1;
    text(panel.querySelector('[data-ns-obi-state]'), activeGift && activeGift.available ? activeGift.name + ' included' : 'Gift unavailable');
    var neo = sameBlade(s, 'Neopixel'), proffie = sameBlade(s, 'Proffie');
    Array.from(panel.querySelectorAll('[data-ns-obi-core]')).forEach(function (button) {
      var variant = sameBlade(s, button.dataset.nsObiCore), item = gift(s, variant), selected = variant && variant.id === s.current.id;
      var enabled = Boolean(variant && variant.available && item && item.available);
      text(button.querySelector('.ns-obi-offer__copy>strong'), button.dataset.nsObiCore + (s.current.option2 === 'No Blade' ? ' · hilt only' : ''));
      button.disabled = !enabled;
      button.setAttribute('aria-pressed', String(Boolean(selected)));
      text(button.querySelector('[data-ns-obi-gift]'), item && item.available ? '+ FREE ' + item.name : 'Gift currently unavailable');
      text(button.querySelector('[data-ns-obi-price]'), variant ? money(panel, variant.price) : 'Unavailable');
      text(button.querySelector('[data-ns-obi-selection]'), selected ? '✓ Selected' : enabled ? 'Choose ' + button.dataset.nsObiCore : 'Unavailable');
      var mainImage = button.querySelector('[data-ns-obi-main]'), giftImage = button.querySelector('[data-ns-obi-gift-image]');
      if (mainImage.getAttribute('src') !== panel.dataset.mainImage) mainImage.src = panel.dataset.mainImage;
      if (item && item.image && giftImage.getAttribute('src') !== item.image) giftImage.src = item.image;
      giftImage.hidden = !item || !item.image;
      button.setAttribute('aria-label', [panel.dataset.productTitle, button.dataset.nsObiCore, variant ? money(panel, variant.price) : 'unavailable', item && item.available ? 'with free ' + item.name : 'gift unavailable', selected ? 'selected' : ''].filter(Boolean).join(', '));
      if (focusCore === button.dataset.nsObiCore && selected) { button.focus({ preventScroll: true }); focusCore = null; }
    });
    var neoGift = gift(s, neo), proffieGift = gift(s, proffie);
    var difference = panel.querySelector('[data-ns-obi-difference]');
    var delta = neo && proffie && proffie.price - neo.price;
    var comparison = delta > 0 && neo.available && proffie.available && neoGift && neoGift.available && proffieGift && proffieGift.available;
    difference.hidden = !comparison;
    if (comparison) {
      if (!difference.querySelector('[data-ns-obi-delta]')) difference.innerHTML = 'Upgrade for just <strong data-ns-obi-delta></strong> more. Get Proffie’s advanced sound and blade customization, plus a <strong data-ns-obi-highlight-gift></strong>.';
      text(difference.querySelector('[data-ns-obi-delta]'), money(panel, delta));
      text(difference.querySelector('[data-ns-obi-highlight-gift]'), 'FREE ' + proffieGift.name);
    }
    var proffieLabel = Array.from(field.querySelectorAll('label')).find(function (label) { var title = label.querySelector('.ns-variant-title'); return title && title.textContent.trim() === 'Proffie'; });
    if (proffieLabel) text(proffieLabel.querySelector('.ns-variant-subtitle'), 'Preset sounds + customization');
    var cta = activeGift && activeGift.available ? 'Add to Cart + FREE ' + activeGift.name : 'Add to Cart';
    if (s.root.dataset.obiGiftCta !== cta) { s.root.dataset.obiGiftCta = cta; if (window.NSPromoAtc) window.NSPromoAtc.refresh(); }
  }
  function schedule() { if (!scheduled) { scheduled = true; window.requestAnimationFrame(render); } }
  function start() {
    var s = state();
    if (!s) return;
    render();
    document.addEventListener('variant:change', schedule);
    document.addEventListener('ns:eligibility', schedule);
    document.addEventListener('change', function (event) { if (event.target.closest('variant-picker[handle="obi-ep1"]')) schedule(); });
    window.addEventListener('pageshow', schedule);
    var section = s.picker.closest('.shopify-section');
    if (section) new MutationObserver(schedule).observe(section, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
